import { render } from "./TestimonioOrderNew.vue?vue&type=template&id=b8928032&scoped=true"
import script from "./TestimonioOrderNew.vue?vue&type=script&lang=js"
export * from "./TestimonioOrderNew.vue?vue&type=script&lang=js"

import "./TestimonioOrderNew.vue?vue&type=style&index=0&id=b8928032&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8928032"]])

export default __exports__